import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes } from '@/types';
import { setURLToDataSource, generateUUID } from '@/tools/helpers';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope area beacons. It shows all Articles which
 * are attached to nearbay area beacons. They are seperated by coresponding locations
 */
export default function({ state, rootState, getters, commit, dispatch }, { options } = { options: {} }) {
	// FIXME: should this be done with some virtual exhibition/article thing?
	// commit(mutationTypes.setNavigation, { navigation: { theme: 'list-area-beacons' } });

	// Articles can be in moren then one exhibition, to prevent unessary exhibition switching current Exhibition
	// is always assing at last. But notice still this can lead to unpredicted behaviour wicht exhibition is selected
	const reducedExhibition = rootState.dataSourceCFG.exhibitions.reduce((acc, entry) => {
		// logger.log('reduce exhibition ', entry);
		acc = Object.assign(
			acc,
			entry.articles.reduce((acc, article) => {
				acc[article[0]] = Object.assign({ exhibitionID: entry.exhibitionID }, article[1]);
				return acc;
			}, {})
		);
		return acc;
	}, {});
	const reducedCurrentExhibition = getters.currentExhibition.articles.reduce((acc, article) => {
		acc[article[0]] = Object.assign({ exhibitionID: getters.currentExhibition.exhibitionID }, article[1]);
		return acc;
	});

	const articleMap = Object.assign(reducedExhibition, reducedCurrentExhibition);
	// logger.log('articleMap', articleMap);

	const data = (options.showAll
		? Object.entries(rootState.dataSourceCFG.beaconDescMap)
		: Object.entries(rootState.areaBeaconAlgorithm.detectedAreaBeacons)
	)
		.map(entry => {
			// logger.log('entry', entry);
			const url = entry[0];
			const beaconDesc = entry[1];
			return {
				key: generateUUID(),
				url: url,
				role:'link',
				articles: rootState.areaBeaconAlgorithm.descriptionMap[url],
				location: rootState.dataSourceCFG.locations
					.filter(location => location.type === 'beacon')
					.reduce((acc, location) => {
						// logger.log('loc', location);
						// logger.log('beaconDesc', entry[1]);
						if (
							location.beaconID &&
							location.beaconID.minor === beaconDesc.minor &&
							location.beaconID.major === beaconDesc.major &&
							location.beaconID.uuid === beaconDesc.uudi
						) {
							// logger.log('found location', location);
							acc = {
								locationID: location._id,
								languageContent: location.languageContent,
								tags: location.tags,
							};
						}
						return acc;
					}),
			};
		})
		.reduce((acc, beaconDesc) => {
			if (beaconDesc.articles) {
				beaconDesc.articles = beaconDesc.articles.map(articleID => articleMap[articleID]);
				acc.push(beaconDesc);
			}
			return acc;
		}, [])
		.reduce((acc, beaconDesc) => {
			// logger.log(beaconDesc);
			// acc.push();
			beaconDesc.articles.forEach(article => {
				const languageContent = article.languageContent.filter(
					lc => lc.languageISO === rootState.persistent.language
				)[0];
				languageContent.cover = languageContent.coverImage
					? setURLToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
					: undefined;
				const location = {
					id: beaconDesc.location.locationID,
					name: `${beaconDesc.location.locationID}`,
					class: `separator--${beaconDesc.location.locationID}`,
					isSeperator: true,
					iconName: 'separator',
					...beaconDesc.location.languageContent.reduce(
						(acc, lc) => {
							if (lc.title) acc.title[lc.languageISO] = lc.title;
							if (lc.description) acc.description[lc.languageISO] = lc.description;
							if (lc.coverImage)
								acc.cover[lc.languageISO] = lc.coverImage
									? setURLToDataSource(`../media-${lc.coverImage}/512`, rootState.dataSourceURL)
									: undefined;
							return acc;
						},
						{ title: {}, description: {}, cover: {} }
					),
				};
				acc.push({
					location,
					id: article.id,
					class: 'data--' + article.id,
					active: `${rootState.articleContent.hasOwnProperty(article.id)}`,
					url: '',
					click: () => {
						commit(mutationTypes.viewStateSetUiState, {
							id: uiComponents.uiSearchAreabeacons,
							uiState: uiStates.hidden,
						});
						dispatch(actionTypes.setExhibition, {
							exhibitionID: article.exhibitionID,
							articleID: article.id,
						});
					},
					...languageContent,
				});
			});
			return acc;
		}, []);

	const alterationFunctions = [
		function(array) {
			return array.reduce(
				(acc, entry) => {
					if (entry.location.id !== acc.seperator) {
						acc.seperator = entry.location.id;
						acc.result.push(entry.location);
					}
					acc.result.push(entry);
					return acc;
				},
				{ seperator: null, result: [] }
			).result;
		},
		function(array) {
			if (state.scopes.areabeacons.query !== '') {
				array.push({
					id: 'alles-exponate',
					name: 'alles-exponate',
					class: 'separator--alles-exponate	',
					isSeperator: true,
					iconName: 'separator',
					title: {
						de: 'Alle Exponate',
						en: 'All exhibits',
					},
				});

				return array.concat(
					state.scopes.areabeacons.searchSubFunction
						.search(state.scopes.areabeacons.query)
						.filter(entry => !array.find(element => element.id === entry.id))
				);
			}
			return array;
		},
	];

	const subData = Object.entries(rootState.dataSourceCFG.beaconDescMap)
		.map(entry => {
			// logger.log('entry', entry);
			const url = entry[0];
			const beaconDesc = entry[1];
			return {
				url: url,
				articles: rootState.areaBeaconAlgorithm.descriptionMap[url],
				location: rootState.dataSourceCFG.locations
					.filter(location => location.type === 'beacon')
					.reduce((acc, location) => {
						// logger.log('loc', location);
						// logger.log('beaconDesc', entry[1]);
						if (
							location.beaconID &&
							location.beaconID.minor === beaconDesc.minor &&
							location.beaconID.major === beaconDesc.major &&
							location.beaconID.uuid === beaconDesc.uudi
						) {
							// logger.log('found location', location);
							acc = {
								locationID: location._id,
								languageContent: location.languageContent,
								tags: location.tags,
							};
						}
						return acc;
					}),
			};
		})
		.reduce((acc, beaconDesc) => {
			if (beaconDesc.articles) {
				beaconDesc.articles = beaconDesc.articles.map(articleID => articleMap[articleID]);
				acc.push(beaconDesc);
			}
			return acc;
		}, [])
		.reduce((acc, beaconDesc) => {
			// logger.log(beaconDesc);
			// acc.push();
			beaconDesc.articles.forEach(article => {
				const languageContent = article.languageContent.filter(
					lc => lc.languageISO === rootState.persistent.language
				)[0];
				languageContent.cover = languageContent.coverImage
					? setURLToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
					: undefined;
				const location = {
					id: beaconDesc.location.locationID,
					name: `${beaconDesc.location.locationID}`,
					class: `separator--${beaconDesc.location.locationID}`,
					isSeperator: true,
					iconName: 'separator',
					...beaconDesc.location.languageContent.reduce(
						(acc, lc) => {
							if (lc.title) acc.title[lc.languageISO] = lc.title;
							if (lc.description) acc.description[lc.languageISO] = lc.description;
							if (lc.coverImage)
								acc.cover[lc.languageISO] = lc.coverImage
									? setURLToDataSource(`../media-${lc.coverImage}/512`, rootState.dataSourceURL)
									: undefined;
							return acc;
						},
						{ title: {}, description: {}, cover: {} }
					),
				};
				acc.push({
					location,
					id: article.id,
					class: 'data--' + article.id,
					active: `${rootState.articleContent.hasOwnProperty(article.id)}`,
					url: '',
					click: () => {
						commit(mutationTypes.viewStateSetUiState, {
							id: uiComponents.uiSearchAreabeacons,
							uiState: uiStates.hidden,
						});
						dispatch(actionTypes.setExhibition, {
							exhibitionID: article.exhibitionID,
							articleID: article.id,
						});
					},
					...languageContent,
				});
			});
			return acc;
		}, []);

	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.areabeacons,
		data,
		subData,
		timestamp: rootState.areaBeaconAlgorithm.timestamp,
		alterationFunctions,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options,
		refresh: () => {
			dispatch(actionTypes.searchShowAreaBeacons, { options });
		},
	});

	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchAreabeacons,
		uiState: uiStates.maximised,
	});
}
